export enum Situacao {
    Ativo = 'Ativo',
    Inativo = 'Inativo',
    OperadoraForaDoAr = 'Operadora fora do ar',
    VerificarSenha = 'Verificar dados de acesso',
    ExigirAcaoUsuario = 'Site exigindo ação do usuário',
    BloqueioDuplaAutenticacao = 'Bloqueio por múltipla autenticação',
    Sincronizando = 'Sincronizando'
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/estabelecimento/situacao.enum.ts